/* eslint-disable react-native/no-inline-styles */
/* eslint-disable react/prop-types */
import React, { useMemo } from 'react';
import { CheckBox } from 'react-native-elements-light';
import { checkbox, checkboxText } from '~assets/styles/checkboxStyles';
import Image from '@web-components/common/Image';

const CheckboxDefault = (props) => {
  const CheckedIcon = useMemo(
    () =>
      props.checkedIcon ? (
        props.checkedIcon
      ) : (
        <React.Fragment key={'image-checkbox'}>
          <Image
            style={props?.styleWrapper || { width: 16, height: 16 }}
            source={require('~assets/img/common/checkbox-checked.png')}
            resizeMode="cover"
          />
        </React.Fragment>
      ),
    [props.checkedIcon],
  );

  const UncheckedIcon = useMemo(
    () =>
      props.uncheckedIcon ? (
        props.uncheckedIcon
      ) : (
        <React.Fragment key={'image-uncheckbox'}>
          <Image
            style={props?.styleWrapper || { width: 16, height: 16 }}
            source={require('~assets/img/common/checkbox.png')}
            resizeMode="cover"
          />
        </React.Fragment>
      ),
    [props.uncheckedIcon],
  );

  return (
    <CheckBox
      {...props}
      textStyle={{ ...checkboxText, ...props.textStyle }}
      containerStyle={{ ...checkbox, ...props.containerStyle }}
      checkedIcon={CheckedIcon}
      uncheckedIcon={UncheckedIcon}
      disabled={props?.disabled}
    />
  );
};

export default React.memo(CheckboxDefault, (prev, next) => prev == next);
